import common from "../../common";

export default class Cookie extends PIXI.Container {
    constructor(texture, cutter, renderTexture) {
        super();

        this._outerContainer = new PIXI.Container();
        this.addChild(this._outerContainer);

        this._innerContainer = new PIXI.Container();
        this._outerContainer.addChild(this._innerContainer);

        this._texture = new PIXI.Sprite(texture);
        this._texture.anchor.set(0.5);
        //this._texture.tint = 0x000000;
        this._texture.scale.set(0.85);
        this._innerContainer.addChild(this._texture);
        this._innerContainer.position.set(this._texture.width + 36, this._texture.height * 0.5 + 113);

        this._mask = new PIXI.Sprite(renderTexture);
        this._mask.tint = 0x000000;
        this._mask.position.set(cutter.position.x, cutter.position.y);
        this._mask.anchor.set(0.5);
        this._mask.width = (renderTexture.width * 0.5) * 0.84 - 10;
        this._mask.height = (renderTexture.height * 0.5) * 0.84 - 10;
        this._outerContainer.addChild(this._mask);
        this._innerContainer.mask = this._mask;

        this._maskSprite = this._mask;
    }
}